import { action } from 'typesafe-actions';
import { IApiQueryOptions } from 'api/ApiClient';
import { IAchTransaction, IApiList } from 'types';
import { Ach } from './types';

export const getSiteAchTransactionsRequest = (siteId: string, options?: IApiQueryOptions) => action(Ach.GET_TRANSACTIONS_REQUEST, { siteId, options });
export const getSiteAchTransactionsSuccess = (response: IApiList<IAchTransaction>) => action(Ach.GET_TRANSACTIONS_SUCCESS, response);
export const getSiteAchTransactionsError = (error: any) => action(Ach.GET_TRANSACTIONS_FAILURE, error);
